var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ProjectSelection"},[_c('h3',{staticClass:"auth-title m-b-20 text-first-uppercase"},[_vm._v(_vm._s(_vm.$t('select_project')))]),_c('ja-projects-tree',{attrs:{"organizations":_vm.organizations,"on-select-project":_vm.assingProject}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }